import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { useGetLanguages } from 'api/commonApi';
import { useUpdateProfileDetails } from 'api/profileApi';
import Form from 'react-bootstrap/Form';
import { getKeyByValue } from 'utils/utils';

import { LANGUAGES } from 'constants/languages';

import './style.scss';

const DEFAULT_LANGUAGE = 'English';

const LanguageDropdown = () => {
  const { t, i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(
    () => getKeyByValue(LANGUAGES, i18n.language) || DEFAULT_LANGUAGE,
  );
  const { data: languagesResponse } = useGetLanguages();
  const { mutate: updateLanguage } = useUpdateProfileDetails({ message: t('languageDropdown.successMessage') });

  const languages = languagesResponse?.data || [];

  const handleChange = (e) => {
    const language = e.target.value;
    setSelectedLanguage(language);
    i18n.changeLanguage(LANGUAGES[language]);
    updateLanguage({ language });
  };

  return (
    <Form.Select
      aria-label={t('languageDropdown.selectLanguage')}
      className="language-dropdown"
      onChange={handleChange}
      value={selectedLanguage}
    >
      {languages.map((language) => (
        <option key={language} value={language}>
          {language}
        </option>
      ))}
    </Form.Select>
  );
};

export default LanguageDropdown;
